export default __webpack_public_path__ + "static/media/ikea-devices-touch-points.bcf28c17.svg";